import axios from 'axios'
import {actionTypes, mimeTypes, mutationTypes} from '../constants'
import {AzSearchUrlBuilder} from '@azinformatica/loki'
import SearchUrlBuilder from '@/commons/utils/SearchUrlBuilder'
import ParamUtils from "@/commons/utils/ParamUtils";
import DownloadUtils from "@/commons/utils/DownloadUtils";
import SearchUrlParamBuilder from "@/commons/utils/SearchUrlParamBuilder";
import api from '@/commons/apiclient'

const downloadUtils = new DownloadUtils()

const commitLicitacao = ({commit}, licitacao) => {
    const {possuiItemComPeriodicidade, ...licitacaoParaEdicao} = licitacao
    commit(mutationTypes.SET_LICITACAO, licitacaoParaEdicao)
    if (possuiItemComPeriodicidade !== undefined) {
        commit(mutationTypes.SET_POSSUI_ITEM_COM_PERIODICIDADE, possuiItemComPeriodicidade === true)
    }
}

export default {

    async [actionTypes.ATRIBUIR_DOMINIO_PERFIL_NOVO_USUARIO](context, dominioPerfilDTO) {
        const {data} = await axios.post(`hal/dominioPerfil/criarDominioEDominioPerfil`, dominioPerfilDTO)
        return data
    },

    async [actionTypes.ATUALIZAR_LICITACAO](context, {licitacaoId, licitacao, atualizarSistemasExternos = false}) {
        const {possuiItemComPeriodicidade, ...licitacaoParaAtualizacao} = licitacao
        const {data} = await axios.put(`api/licitacoes/${licitacaoId}?atualizarSistemasExternos=${atualizarSistemasExternos}`, licitacaoParaAtualizacao)
        return data
    },

    async [actionTypes.ATUALIZAR_EDITAL](context, {licitacaoId, licitacao}) {
        const {data} = await axios.put(`api/licitacoes/${licitacaoId}/atualizar-edital`, licitacao)
        return data
    },

    async [actionTypes.ATUALIZAR_LOTES_ITENS]({commit}, {licitacaoId, lotesItens}) {
        const {data} = await axios.put(`api/licitacoes/${licitacaoId}/lotes`, lotesItens)
        commit(mutationTypes.SET_LOTES_LICITACAO, data)
    },

    async [actionTypes.ATUALIZAR_PROPOSTA_ITENS](context, {licitacaoId, payload}) {
        const {data} = await axios.post(`api/propostas/${licitacaoId}`, payload)
        return data
    },

    async [actionTypes.ATUALIZAR_ITEM_PROPOSTA](context, {licitacaoId, payload}) {
        const {data} = await axios.post(`api/propostas/item/${licitacaoId}`, payload)
        return data
    },

    async [actionTypes.ATUALIZAR_SESSAO_DOMINIO](context, {dominioClienteId, dominioTipo}) {
        await axios.put(`hal/usuario/sessao/atualizarSessao?dominioIdCliente=${dominioClienteId}&dominioTipoCliente=${dominioTipo}`)
    },

    async [actionTypes.ATUALIZAR_USUARIO](context, usuario) {
        usuario.pais = usuario.pais.id
        usuario.idioma = usuario.idioma.initials
        await axios.put(`hal/usuarios/${usuario.id}`, usuario)
    },

    async [actionTypes.CREDENCIAMENTO.BUSCAR_INFORMACOES_USUARIO]() {
        const {data} = await axios.get('/hal/auth/usuario/info')
        return data
    },

    async [actionTypes.BUSCAR_ANEXOS_LICITACAO]({commit}, licitacaoId) {
        const {data} = await axios.get(`api/licitacoes/${licitacaoId}/anexos`)
        commit(mutationTypes.SET_ANEXOS_LICITACAO, data)
    },

    async [actionTypes.BUSCAR_CANDIDATOS_COMISSAO](context, comissaoId) {
        const {data} = await axios.get(`api/configuracoes/comissoesApuracao/${comissaoId}/candidatos`)
        return data
    },

    async [actionTypes.BUSCAR_COMISSAO_APURACAO]({commit}, comissaoId) {
        const {data} = await axios.get(`api/configuracoes/comissoesApuracao/${comissaoId}`)
        commit(mutationTypes.SET_COMISSAO, data)
    },

    async [actionTypes.BUSCAR_COMISSOES_APURACAO](context, situacao) {
        const url = 'api/configuracoes/comissoesApuracao' + (situacao ? `?situacao=${situacao}` : '')
        const {data} = await axios.get(url)
        return data
    },

    async [actionTypes.BUSCAR_COMISSOES_APURACAO_POR_FILTRO]({state}) {
        const filtros = state.comissaoBusca.filtros
        const url = AzSearchUrlBuilder.build('api/configuracoes/comissoesApuracao', filtros)
        const {data} = await axios.get(url)
        return data
    },

    async [actionTypes.BUSCAR_COMISSOES_APURACAO_PAGINADO]({state}) {
        const {filtros, paginacao} = state.comissaoBusca
        const {data} = await api.licitacao.buscaPaginadaDeComissoes(filtros, paginacao)
        return data
    },

    async [actionTypes.BUSCAR_RESPONSAVEIS_COMISSAO](context, comissaoId) {
        const {data} = await axios.get(`api/comissoes/${comissaoId}/responsaveis`)
        return data
    },

    async [actionTypes.BUSCAR_CONFIGURACOES_NOVO_USUARIO]() {
        const {data} = await axios.get('api/configuracoes/comissoesApuracao/usuarios/informacoesParaNovoUsuario')
        return data
    },

    async [actionTypes.BUSCAR_DOCUMENTOS_PROPOSTA](context, licitacaoId) {
        const {data} = await axios.get(`api/propostas/${licitacaoId}/documentos`)
        return data
    },

    async [actionTypes.BUSCAR_DOCUMENTOS_REMESSA](context, licitacaoId) {
        const {data} = await axios.get(`api/licitacoes/${licitacaoId}/documentos-remessa`)
        return data
    },

    async [actionTypes.BUSCAR_FORNECEDOR_ACEITE]({commit}, {licitacaoId}) {
        const {data} = await axios.get(`api/propostas/${licitacaoId}/termos/informacoesAceite`)
        commit(mutationTypes.SET_FORNECEDOR_ACEITE, data)
    },

    async [actionTypes.BUSCAR_LICITACAO]({commit}, licitacaoId) {
        const {data} = await axios.get(`api/licitacoes/${licitacaoId}`)
        commitLicitacao({commit}, data)
    },

    async [actionTypes.BUSCAR_LICITACAO_PROPOSTA_ITENS]({commit}, licitacaoId) {
        const {data} = await axios.get(`api/propostas/${licitacaoId}/itens`)
        commit(mutationTypes.SET_LICITACAO_PROPOSTA_ITENS, data)
    },

    async [actionTypes.BUSCAR_LICITACOES]({state}) {
        const {filtros, paginacao} = state.licitacaoBusca
        const url = AzSearchUrlBuilder.build('api/licitacoes/', filtros, paginacao)
        const {data} = await axios.get(url)
        return data
    },

    async [actionTypes.BUSCAR_LICITACOES_LEGADO]({state}) {
        const {filtros, paginacao} = state.licitacaoBusca
        const url = AzSearchUrlBuilder.build('api/legado/buscarlicitacoes', filtros, paginacao)
        const {data} = await axios.get(url)
        return data
    },

    async [actionTypes.BUSCAR_LICITACAO_LEGADO]({commit}, licitacaoId) {
        const formattedLicitacaoId = licitacaoId.replace('/', '-')
        const {data} = await axios.get(`api/legado/buscarlicitacao/${formattedLicitacaoId}`)
        commit(mutationTypes.SET_LICITACAO_LEGADO, data)
    },

    async [actionTypes.BUSCAR_ESCLARECIMENTOS_IMPUGNACOES_LEGADO]({commit}, licitacaoId) {
        const formattedLicitacaoId = licitacaoId.replace('/', '-')
        const {data} = await axios.get(`api/legado/buscaresclarecimentosimpugnacoes/${formattedLicitacaoId}`)
        commit(mutationTypes.SET_ESCLARECIMENTOS_IMPUGNACAOES_LEGADO, data)
    },

    async [actionTypes.BUSCAR_FORNECEDORES_LEGADO](context, payload) {
        const formattedLicitacaoId = payload.idProcesso.replace('/', '-')
        const {data} = await axios.get("api/legado/buscarfornecedores", {
            params: {idProcesso: formattedLicitacaoId, idLote: payload.idLote}
        });
        return data;
    },

    async [actionTypes.BUSCAR_LICITACOES_FAVORITAS_FORNECEDOR]({state}) {
        const paginacao = state.licitacoesFavoritasFornecedorBusca.paginacao
        const url = AzSearchUrlBuilder.build('api/licitacoes/favoritos', {}, paginacao)
        const {data} = await axios.get(url)
        return data
    },

    async [actionTypes.BUSCAR_LICITACOES_FORNECEDOR_ACONTECENDO_HOJE]() {
        const {data} = await axios.get('api/propostas/acontecendoHoje')
        return data
    },

    async [actionTypes.BUSCAR_LICITACOES_FORNECEDOR_COM_PROPOSTA]({state}) {
        const paginacao = state.licitacoesFornecedorComProposta.paginacao
        const url = AzSearchUrlBuilder.build('api/propostas/minhas', {}, paginacao)
        const {data} = await axios.get(url)
        return data
    },

    async [actionTypes.BUSCAR_LOTES_ITEM_POR_LICITACAO]({commit}, licitacaoId) {
        const {data} = await axios.get(`api/licitacoes/${licitacaoId}/lotes`)
        commit(mutationTypes.SET_LOTES_LICITACAO, data)
    },

    async [actionTypes.BUSCAR_NOMES_MODELOS_IMPORTACAO]() {
        const {data} = await axios.get('api/modelosImportacao/nomes')
        return data
    },

    async [actionTypes.BUSCAR_NOMES_MODELOS_EXPORTACAO]() {
        const {data} = await axios.get('api/modelosExportacao/nomes')
        return data
    },

    async [actionTypes.BUSCAR_ORGAOS]({commit}) {
        const {data} = await axios.get('api/configuracoes/orgaos')
        commit(mutationTypes.SET_ORGAOS, data)
        return data
    },

    async [actionTypes.ATIVAR_INTEGRACAO_IPM]({commit}, {orgaoId, ativa}) {
        await axios.put(`api/configuracoes/orgaos/ativarIPM/${orgaoId}?integracaoAtiva=${ativa}`)
    },

    async [actionTypes.IMPORTAR_PROCESSO_IPM](context, payload) {
        const {data} = await axios.post('api/ipm/importar', payload)
        return data
    },

    async [actionTypes.IMPORTAR_PROCESSO_ARQUIVO](context, payload) {
        const {data} = await axios.post('api/v1/importar-processo-arquivo', payload)
        return data
    },

    async [actionTypes.BUSCAR_ORGAOS_USUARIO]() {
        const {data} = await axios.get('api/orgaos-usuario')
        return data
    },

    async [actionTypes.BUSCAR_PLANO_ASSINATURA]() {
        return await axios.get('api/configuracoes/planoAssinatura')
    },

    async [actionTypes.BUSCAR_PRODUTO_POR_NOME]({commit}, packageJson) {
        const name = 'licitacao'
        const {data} = await axios.get(`hal/public/produtos?produtoNome=${name}`)
        commit(mutationTypes.SET_PRODUTO, {data, packageJson})
    },

    async [actionTypes.BUSCAR_SETUP]({commit}) {
        const name = 'setup'
        const {data} = await axios.get(`hal/public/produtos?produtoNome=${name}`)
        const usuario = await axios.get(`hal/usuario/sessao?produtoId=${data.id}`)
        commit(mutationTypes.SET_USUARIO_SETUP, usuario.data)
    },

    async [actionTypes.BUSCAR_PROPOSTA_RESUMO]({commit}, licitacaoId) {
        const {data} = await axios.get(`api/propostas/${licitacaoId}/resumo`)
        commit(mutationTypes.SET_PROPOSTA_RESUMO, data)
        commitLicitacao({commit}, data.licitacao)
        commit(mutationTypes.SET_FORNECEDOR_ACEITE, data.fornecedor)
        commit(mutationTypes.SET_TERMO_ACEITE_PROPOSTA, data.propostaTermo)
    },

    async [actionTypes.BUSCAR_TOKEN_ACESSO_PREGAO](context, {licitacaoId, usuarioId}) {
        const {data} = await axios.get(`api/licitacoes/token?licitacaoId=${licitacaoId}&usuarioId=${usuarioId}`)
        return data
    },

    async [actionTypes.BUSCAR_URL_COMPRA_DIRETA]({commit}) {
        const {data} = await axios.get('api/integration/compra-direta/url')
        commit(mutationTypes.SET_URL_COMPRA_DIRETA, data)
    },

    async [actionTypes.BUSCAR_USUARIO]({commit}, usuarioId) {
        const {data} = await axios.get(`hal/usuarios/${usuarioId}`)
        commit(mutationTypes.SET_USUARIO, data)
    },

    async [actionTypes.BUSCAR_USUARIO_INTERNO]({commit}, usuarioId) {
        const {data} = await axios.get(`api/usuario-interno/${usuarioId}/buscar`)
        commit(mutationTypes.SET_USUARIO, data)
    },

    async [actionTypes.BUSCAR_USUARIO_DOMINIO_PERFIL]({commit}, {usuarioId, perfil}) {
        const {data} = await axios.get(`api/configuracoes/usuarios/${usuarioId}/perfis?perfil=${perfil}`)
        commit(mutationTypes.SET_PERFIS, data)
    },

    async [actionTypes.BUSCAR_USUARIOS]({state}) {
        const filtros = state.usuarioBusca.filtros
        const url = AzSearchUrlBuilder.build('api/configuracoes/comissoesApuracao/usuarios', filtros)
        const {data} = await axios.get(url)
        return data
    },

    async [actionTypes.BUSCAR_USUARIOS_INTERNOS]({state}) {
        const filtros = state.usuarioBusca.filtros
        const url = AzSearchUrlBuilder.build('api/configuracoes/comissoesApuracao/usuarios-internos', filtros)
        const {data} = await axios.get(url)
        return data
    },

    async [actionTypes.BUSCAR_USUARIO_LOGADO]({commit, state}) {
        const produtoId = state.loki.product.id
        const {data} = await axios.get(`hal/usuario/sessao?produtoId=${produtoId}`)
        commit(mutationTypes.SET_USUARIO_LOGADO, data)
    },

    async [actionTypes.BUSCAR_LINK_EDITAR_USUARIO]({state}) {
        const payload = {
            uri: window.location.origin + window.location.pathname,
            produto: state.loki.product.name
        }
        const {data} = await axios.post('hal/editarUsuario', payload)
        return data
    },

    async [actionTypes.CANCELAR_ENVIO_PROPOSTA](context, {licitacaoId}) {
        await axios.put(`api/propostas/${licitacaoId}/cancelamento`)
    },

    async [actionTypes.DESFAVORITAR_LICITACAO](context, licitacaoId) {
        await axios.delete(`api/licitacoes/${licitacaoId}/favoritos`)
    },

    async [actionTypes.ENVIAR_EMAIL_INFO_LOGIN](context, usuarioId) {
        await axios.put(`hal/usuarios/${usuarioId}/reenviarSenhaEmail`)
    },

    async [actionTypes.EXPORTAR_LOTES_ITENS](context, {licitacaoId, nomeModelo}) {
        const {
            data,
            headers
        } = await axios.get(`api/licitacoes/${licitacaoId}/lotes/exportacao?nomeModelo=${nomeModelo}`)
        let blob = new Blob([data], {type: 'text/plain'})
        const downloadLink = document.createElement('a')
        downloadLink.setAttribute('type', 'hidden')
        downloadLink.href = window.URL.createObjectURL(blob)
        downloadLink.download = 'exportação-itens.txt'
        if (headers && headers.filename)
            downloadLink.download = headers.filename
        document.body.appendChild(downloadLink)
        downloadLink.click()
        document.body.removeChild(downloadLink)
    },

    async [actionTypes.EXPORTAR_LOTES_ITENS_SGC](context, {licitacaoId}) {
        const {data} = await axios.post(`api/licitacoes/${licitacaoId}/lotes/exportacaoSgc`)
        return data
    },

    async [actionTypes.EXPORTAR_RESULTADO_IPM](context, licitacaoId) {
        const {data} = await axios.post(`api/ipm/${licitacaoId}/enviarResultado`)
        return data
    },

    async [actionTypes.ENVIAR_PROPOSTA](context, {licitacaoId, idMoedaEstrangeira}) {
        let url

        if (idMoedaEstrangeira) {
            url = `api/propostas/${licitacaoId}/envio?idMoedaEstrangeira=${idMoedaEstrangeira}`
        } else {
            url = `api/propostas/${licitacaoId}/envio`
        }

        const {data} = await axios.put(url)
        return data
    },

    async [actionTypes.FAVORITAR_LICITACAO](context, licitacaoId) {
        await axios.post(`api/licitacoes/${licitacaoId}/favoritos`)
    },

    async [actionTypes.IMPORTAR_LOTES_ITEM_PLANILHA]({commit}, {licitacaoId, arquivo}) {
        const {data} = await axios.post(`api/licitacoes/${licitacaoId}/lotes/importacaoPlanilha`, {uriArquivoPlanilha: arquivo.uri})
        commit(mutationTypes.SET_LOTES_LICITACAO, data)
    },

    async [actionTypes.IMPORTAR_LOTES_ITEM_TXT]({commit}, {licitacaoId, arquivo, nomeModelo}) {
        const {data} = await axios.post(`api/licitacoes/${licitacaoId}/lotes/importacaoTxt`,
            {uriArquivoTexto: arquivo.uri, nomeModelo})
        commit(mutationTypes.SET_LOTES_LICITACAO, data)
    },

    async [actionTypes.INSERIR_ANEXOS_LICITACAO](context, {licitacaoId, anexos}) {
        await axios.post(`api/licitacoes/${licitacaoId}/anexos`, anexos)
    },

    async [actionTypes.INSERIR_COMISSAO](context, comissao) {
        const {data} = await axios.post(`api/configuracoes/comissoesApuracao`, comissao)
        return data
    },

    async [actionTypes.ATUALIZAR_COMISSAO](context, comissao) {
        const {data} = await axios.put(`api/configuracoes/comissoesApuracao`, comissao)
        return data
    },

    async [actionTypes.INSERIR_DOCUMENTOS_PROPOSTA](context, {licitacaoId, documentos}) {
        await axios.post(`api/propostas/${licitacaoId}/inserirDocumentosProposta`, documentos)
    },

    async [actionTypes.INSERIR_DOCUMENTOS_HABILITACAO](context, {licitacaoId, documentos}) {
        await axios.post(`api/propostas/${licitacaoId}/documentos`, documentos)
    },

    async [actionTypes.INSERIR_LICITACAO](context, licitacao) {
        const {data} = await axios.post('api/licitacoes/', licitacao)
        return data
    },

    async [actionTypes.REFAZER_LICITACAO](context, licitacaoId) {
        const {data} = await axios.post(`api/licitacoes/${licitacaoId}/refazer`)
        return data
    },

    async [actionTypes.INSERIR_MEMBRO_COMISSAO](context, {comissaoId, comissaoUsuario}) {
        const {data} = await axios.put(`api/configuracoes/comissoesApuracao/${comissaoId}/usuarios`, comissaoUsuario)
        return data
    },

    async [actionTypes.ATUALIZAR_USUARIO_COMISSAO](context, {comissaoId, atualizarComissaoUsuarioInput}) {
        await axios.put(`api/configuracoes/comissoesApuracao/${comissaoId}/usuario/atualizar`, atualizarComissaoUsuarioInput)
    },

    async [actionTypes.INSERIR_TERMO_LICITACAO](context, {licitacaoId, isMeEppMei, termosAceitos}) {
        await axios.post(`api/propostas/${licitacaoId}/termos?isMeEppMei=${isMeEppMei}`, termosAceitos)
    },

    async [actionTypes.INSERIR_USUARIO](context, usuario) {
        const {data} = await axios.post(`api/usuario/inserir`, usuario)
        return data
    },

    async [actionTypes.PUBLICAR_LICITACAO](context, licitacaoId) {
        await axios.put(`api/licitacoes/${licitacaoId}/publicacao`)
    },

    async [actionTypes.ATUALIZAR_DATA_TENTATIVA_PUBLICACAO_PNCP](context, licitacaoId) {
        await axios.put(`api/licitacoes/${licitacaoId}/atualizar-data-tentativa-publicacao-pncp`)
    },

    async [actionTypes.REMOVER_ARQUIVO_PROPOSTA_ITEM](context, {
        licitacaoId,
        tipoArquivo,
        propostaId,
        licitacaoLoteItemId
    }) {
        await axios.delete(`api/propostas/${licitacaoId}/itens/${tipoArquivo}/${propostaId}/${licitacaoLoteItemId}`)
    },

    async [actionTypes.REMOVER_ANEXO_LICITACAO](context, {licitacaoId, anexoId}) {
        await axios.delete(`api/licitacoes/${licitacaoId}/anexos/${anexoId}`)
    },

    async [actionTypes.REMOVER_DOCUMENTO_PROPOSTA](context, {licitacaoId, documentoId}) {
        await axios.delete(`api/propostas/${licitacaoId}/documentos/${documentoId}`)
    },

    async [actionTypes.REMOVER_LICITACAO](context, {licitacaoId, justificativa}) {
        await axios.post(`api/licitacoes/${licitacaoId}/remover`, {licitacaoId, justificativa})
    },

    async [actionTypes.REMOVER_LOTES_ITEM](context, {licitacaoId}) {
        await axios.delete(`api/licitacoes/${licitacaoId}/lotes`)
    },

    async [actionTypes.REMOVER_MEMBRO_COMISSAO](context, {comissaoApuracaoId, usuarioId}) {
        await axios.delete(`api/configuracoes/comissoesApuracao/${comissaoApuracaoId}/usuarios/${usuarioId}`)
    },

    async [actionTypes.BUSCAR_QTD_PROPOSTAS_POR_LICITACAO](context, licitacaoId) {
        const {headers} = await axios.head(`api/propostas/${licitacaoId}`)
        return headers['x-total-count']
    },

    async [actionTypes.ATIVAR_ANEXO_LICITACAO](context, {licitacaoId, anexoId}) {
        await axios.put(`api/licitacoes/${licitacaoId}/anexos/${anexoId}/ativacao`)
    },

    async [actionTypes.INATIVAR_ANEXO_LICITACAO](context, {licitacaoId, anexoId}) {
        await axios.put(`api/licitacoes/${licitacaoId}/anexos/${anexoId}/inativacao`)
    },

    async [actionTypes.ENVIAR_MAIS_BRASIL](context, {licitacaoId, payload}) {
        const {data} = await axios.post(`api/licitacoes/${licitacaoId}/maisbrasil/`, payload)
        return data
    },

    async [actionTypes.IMPRIMIR_HISTORICO_MAIS_BRASIL](context, {licitacaoId}) {
        axios({
            url: `api/licitacoes/${licitacaoId}/maisbrasil/`,
            method: 'GET',
            responseType: 'blob',
        }).then((response) => {
            var fileURL = window.URL.createObjectURL(new Blob([response.data]))
            var fileLink = document.createElement('a')

            fileLink.href = fileURL
            fileLink.setAttribute('download', 'HistoricoEnvioMaisBrasil.pdf')
            document.body.appendChild(fileLink)

            fileLink.click()
        })
    },
    async [actionTypes.BUSCAR_UFS]() {
        const {data} = await axios.get(`hal/public/localizacoes/estados`)
        return data;
    },

    async [actionTypes.BUSCAR_MUNICIPIOS](context, {ufId}) {
        const {data} = await axios.get(`hal/public/localizacoes/estados/${ufId}/municipios`)
        return data;
    },

    async [actionTypes.BUSCAR_ORGAO](context, {orgaoId}) {
        const {data} = await axios.get(`hal/unidadeOrganizacional/${orgaoId}`);
        return data;
    },

    async [actionTypes.BUSCAR_ESCLARECIMENTOS]({commit}, licitacaoId) {
        const {data} = await axios.get(`api/licitacoes/${licitacaoId}/esclarecimentos`)
        commit(mutationTypes.SET_ESCLARECIMENTOS_LICITACAO, data.esclarecimentos)
        return data
    },

    async [actionTypes.BUSCAR_IMPUGNACOES]({commit}, licitacaoId) {
        const {data} = await axios.get(`api/licitacoes/${licitacaoId}/impugnacoes`)
        commit(mutationTypes.SET_IMPUGNACOES_LICITACAO, data.impugnacoes)
        return data
    },

    async [actionTypes.INSERIR_ESCLARECIMENTO_IMPUGNACAO](context, {licitacaoId, solicitacao}) {
        const formData = new FormData()
        formData.append('input', new Blob([JSON.stringify(solicitacao)], {type: 'application/json'}))
        if (solicitacao.anexoUpload) {
            formData.append('anexo', solicitacao.anexoUpload)
        }
        await axios.post(`api/licitacoes/${licitacaoId}/esclarecimentoImpugnacao`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        })
    },

    async [actionTypes.EDITAR_ESCLARECIMENTO_IMPUGNACAO](context, solicitacao) {
        const formData = new FormData()
        formData.append('input', new Blob([JSON.stringify(solicitacao)], {type: 'application/json'}))
        if (solicitacao.anexoUpload) {
            formData.append('anexo', solicitacao.anexoUpload)
        }
        const {data} = await axios.put(`api/licitacoes/esclarecimentoImpugnacao/${solicitacao.id}`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        })
        return data
    },

    async [actionTypes.ENVIAR_ESCLARECIMENTO_IMPUGNACAO](context, solicitacaoId) {
        const {data} = await axios.post(`api/licitacoes/esclarecimentoImpugnacao/${solicitacaoId}/enviar`)
        return data
    },

    async [actionTypes.INSERIR_RESPOSTA](context, resposta) {

        const formData = new FormData()
        if (resposta.anexoUpload) {
            formData.append('anexo', resposta.anexoUpload)
        }
        resposta.anexoUpload = null
        formData.append('input', new Blob([JSON.stringify(resposta)], {type: 'application/json'}))
        if (resposta.convidado) {
            const {data} = await axios.post(`api/licitacoes/convidado/esclarecimento-impugnacao/${resposta.esclarecimento}/responder`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            })
            return data
        } else {
            const {data} = await axios.post(`api/licitacoes/${resposta.esclarecimento}`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            })
            return data
        }
    },

    async [actionTypes.INSERIR_RECURSO](context, dados) {
        const {data} = await axios.post(`api/licitacoes/${dados.licitacaoId}/recurso`, dados)
        return data
    },

    async [actionTypes.INSERIR_CONTRARRAZAO](context, dados) {
        const {data} = await axios.post(`api/licitacoes/${dados.licitacaoId}/contrarrazao`, dados)
        return data
    },

    async [actionTypes.INSERIR_RESPOSTA_RECURSO](context, dados) {
        const {data} = await axios.post(`api/licitacoes/${dados.licitacaoId}/responder-recurso`, dados)
        return data
    },

    async [actionTypes.INSERIR_RESPOSTA_CONTRARRAZAO](context, dados) {
        const {data} = await axios.post(`api/licitacoes/${dados.licitacaoId}/responder-contrarrazao`, dados)
        return data
    },

    async [actionTypes.EDITAR_RECURSO](context, dados) {
        const {data} = await axios.put(`api/licitacoes/recurso/${dados.recursoId}`, dados)
        return data
    },

    async [actionTypes.EDITAR_CONTRARRAZAO](context, dados) {
        const {data} = await axios.put(`api/licitacoes/contrarrazao/${dados.contrarrazaoId}`, dados)
        return data
    },

    async [actionTypes.ENVIAR_RECURSO](context, dados) {
        const {data} = await axios.post(`api/licitacoes/recurso/${dados.recursoId}/enviar`, dados)
        return data
    },

    async [actionTypes.ENVIAR_CONTRARRAZAO](context, dados) {
        const {data} = await axios.post(`api/licitacoes/contrarrazao/${dados.contrarrazaoId}/enviar`, dados)
        return data
    },

    async [actionTypes.DOWNLOAD_RELATORIO_RECURSO_CONTRARRAZAO](context, dados) {
        try {
            const response = await axios.get(`api/recursocontrarrazao/${dados.recursoId}/relatorio?tipo=${dados.tipo}`, {
                responseType: 'blob'
            });

            const fileURL = window.URL.createObjectURL(new Blob([response.data], {type: 'application/pdf'}));
            const fileLink = document.createElement('a');

            fileLink.href = fileURL;
            fileLink.setAttribute('target', '_blank');
            document.body.appendChild(fileLink);

            fileLink.click();

            document.body.removeChild(fileLink);

        } catch (error) {
            console.error('Erro ao baixar o relatório', error);
        }
    },

    async [actionTypes.UPLOAD_ARQUIVO_PROMOTE](context, arquivo) {
        let formData = new FormData()
        formData.append('file', arquivo)

        const {data} = await axios.post('api/arquivo/upload', formData, {headers: {'Content-Type': 'multipart/form-data'}})
        return data
    },

    async [actionTypes.BUSCAR_RESPOSTA_ESCLARECIMENTO_IMPUGNACAO](context, esclarecimentoImpugnacaoId) {
        const {data} = await axios.get(`api/licitacoes/${esclarecimentoImpugnacaoId}/respostas`)
        return data
    },

    async [actionTypes.BUSCAR_USUARIOS_PARA_RESPONDER_ESCLARECIMENTO_IMPUGNACAO](context, {
        esclarecimentoImpugnacaoId,
        nome,
        page,
        size
    }) {
        const {data} = await axios.get(`api/licitacoes/esclarecimento-impugnacao/${esclarecimentoImpugnacaoId}/usuarios-para-responder`, {
            params: {nome, page, size}
        })
        return data
    },

    async [actionTypes.CONVIDAR_USUARIO_PARA_RESPONDER_ESCLARECIMENTO_IMPUGNACAO](context, {
        esclarecimentoImpugnacaoId,
        usuarioId,
        nome,
        email
    }) {
        const {data} = await axios.post(`api/licitacoes/esclarecimento-impugnacao/${esclarecimentoImpugnacaoId}/convidar-usuario`, {
            esclarecimentoImpugnacaoId,
            usuarioId,
            nome,
            email
        })
        return data
    },

    async [actionTypes.BUSCAR_USUARIOS_CONVIDADOS_PARA_RESPONDER_ESCLARECIMENTO_IMPUGNACAO](context, esclarecimentoImpugnacaoId) {
        const {data} = await axios.get(`api/licitacoes/esclarecimento-impugnacao/${esclarecimentoImpugnacaoId}/usuarios-convidados-para-responder`)
        return data
    },

    // Busca paginada de esclarecimentos para usuário convidado
    async [actionTypes.BUSCAR_ESCLARECIMENTOS_USUARIO_CONVIDADO](context, {
        usuarioId,
        tipo,
        filtros = {},
        page = 0,
        size = 10
    } = {}) {
        if (!usuarioId) {
            throw new Error('usuarioId é obrigatório para buscar esclarecimentos de usuário convidado')
        }
        const params = Object.assign({}, filtros, {page, size})
        const {data} = await axios.get(`api/licitacoes/convidado/esclarecimento-impugnacao/usuario-convidado/${usuarioId}/${tipo}`, {params})
        return data
    },

    async [actionTypes.BUSCAR_IMAGENS_ITEM_BASE64](context, {itemId}) {
        const {data} = await axios.get(`api/public/licitacoes/itens/${itemId}/imagens/base64`)
        return data.imagens
    },

    async [actionTypes.EXCLUIR_IMAGEM_ITEM](context, {idImagem}) {
        const {data} = await axios.delete(`api/licitacoes/itens/imagem/${idImagem}`)
        return data
    },

    async [actionTypes.INSERIR_IMAGENS_ITEM](context, payload) {
        const {data} = await axios.post(`api/licitacoes/itens/${payload.itemId}/imagens`, payload)
        return data
    },

    async [actionTypes.BUSCAR_DADOS_ASSINATURAS_FORNECEDOR]() {
        const {data} = await axios.get('api/integration/fourbilling/buscarDadosAssinaturas')
        return data
    },

    async [actionTypes.BUSCAR_PLANOS_FORNECEDOR]() {
        const {data} = await axios.get(`api/integration/fourbilling/buscarPlanos`)
        return data
    },

    async [actionTypes.BUSCAR_COBRANCAS_FORNECEDOR]({state}) {
        let {filtros, paginacao} = state.planoFaturas
        const url = AzSearchUrlBuilder.build('api/integration/fourbilling/buscarCobrancas', filtros, paginacao)
        const {data} = await axios.get(url)
        return data
    },

    async [actionTypes.BUSCAR_PLANO_POR_ID](context, planoId) {
        const {data} = await axios.get(`api/integration/fourbilling/buscarPlanoPorId/${planoId}`)
        return data
    },

    async [actionTypes.INSERIR_ASSINATURA_FORNECEDOR](context, dados) {
        const {data} = await axios.post('api/integration/fourbilling/inserirAssinatura/', dados)
        return data
    },

    async [actionTypes.BUSCAR_COBRANCAS_POR_ASSINATURA]({state}, assinaturaId) {
        let {filtros, paginacao} = state.cobrancasPorAssinatura
        filtros.idAssinatura.value = assinaturaId
        const url = AzSearchUrlBuilder.build('api/integration/fourbilling/buscarCobrancasPorAssinatura', filtros, paginacao)
        const {data} = await axios.get(url)
        return data
    },

    async [actionTypes.INSERIR_CLIENTE_FOURBILLING]() {
        const {data} = await axios.post('api/integration/fourbilling/inserirCliente')
        return data
    },

    async [actionTypes.BUSCAR_AMPARO_LEGAL_SITUACAO](context, situacao) {
        const {data} = await axios.get(`api/amparoLegal/buscarPorSituacao/${situacao}`)
        return data
    },

    async [actionTypes.BUSCAR_PROCESSOS_DISPONIVEIS]({commit}, conteudo) {
        const {data} = await axios.get(`api/processos-disponiveis-importacao?conteudo=${conteudo}`)
        commit(mutationTypes.SET_AUTOCOMPLETE_IMPORTAR_LICITACAO, data.processos)
    },

    async [actionTypes.IMPORTAR_PROCESSO](context, processo) {
        const {data} = await axios.post('api/licitacoes/importacao', processo)
        return data
    },

    async [actionTypes.BUSCAR_PARAMETROS]({commit}, processo) {
        const {data} = await axios.get('api/licitacao/parametros', processo)
        commit(mutationTypes.SET_PARAMETROS, data)
    },

    async [actionTypes.EXIBIR_NO_PNCP]({state}, {cnpjOrgaoSuperiorPncp, ano, sequencialCompraPublica}) {
        let baseUrlPncp = state.parametros.propriedadesLicitacao.integration.pncp.uri
        if (baseUrlPncp.includes('api/')) {
            baseUrlPncp = baseUrlPncp.substring(0, baseUrlPncp.indexOf('api/'))
        }

        const urlMontada = `${baseUrlPncp}editais/${cnpjOrgaoSuperiorPncp}/${ano}/${sequencialCompraPublica}`
        window.open(urlMontada, '_blank')
    },

    async [actionTypes.DESPUBLICAR_LICITACAO](context, dados) {
        const {data} = await axios.post(`api/licitacoes/${dados.licitacaoId}/despublicacao`, dados)
        return data
    },

    async [actionTypes.SUSPENDER_LICITACAO](context, dados) {
        await axios.post(`api/licitacoes/${dados.licitacaoId}/suspender`, dados)
    },

    async [actionTypes.BUSCAR_RECURSOS_CONTRARRAZOES](context, licitacaoId) {
        const {data} = await axios.get(`api/licitacoes/recursocontrarrazao/${licitacaoId}`)
        return data
    },

    async [actionTypes.BUSCAR_LOTES_RECURSO_PERMITIDO](context, licitacaoId) {
        const {data} = await axios.get(`api/licitacoes/lotesrecurso/${licitacaoId}`)
        return data
    },

    async [actionTypes.BUSCAR_DOCUMENTOS_LICITACAO]({commit}, {licitacaoId, filtros, paginacao}) {
        const urlBase = `api/licitacoes/documentoslicitacao/${licitacaoId}`
        const url = SearchUrlBuilder.build(urlBase, filtros, paginacao)
        const {data} = await axios.get(url)
        return data
    },

    async [actionTypes.FLOWBEE.JUNTAR_EM_LOTE](context, requestObj) {
        const url = `api/licitacoes/${requestObj.licitacaoId}/documentos/juntar`
        const {data} = await axios.put(url, requestObj)
        return data
    },

    async [actionTypes.FLOWBEE.CANCELAR_DOCUMENTO](context, payload) {
        const url = `api/licitacoes/${payload.licitacaoId}/documentos/2/cancelar`
        const {data} = await axios.put(url, payload)
        return data
    },

    async [actionTypes.FLOWBEE.ASSINAR_EM_LOTE](context, {documentosIds, licitacaoId}) {
        const url = `api/licitacoes/documentos/assinar-em-lote`
        const {data} = await axios.post(url,
            {
                "idsDocumentosVirtualizados": documentosIds,
                "licitacaoId": licitacaoId
            })
        return data
    },

    async [actionTypes.FLOWBEE.JUNTAR_DOCUMENTO](context, payload) {
        const url = `api/licitacoes/${payload.licitacaoId}/documentos/${payload.documentoId}/juntar`
        const {data} = await axios.put(url, payload)
        return data
    },

    async [actionTypes.FLOWBEE.BAIXAR_DOCUMENTO](context, paramObj) {
        const {data} = await axios.get(
            `api/v1/comprador/virtualizacao/download?` +
            ParamUtils.ObjectsToParams([paramObj]),
            {
                responseType: 'arraybuffer'
            }
        )
        downloadUtils.baixarBlob(data, paramObj.nomeArquivo, mimeTypes.pdf.valor)
    },

    async [actionTypes.FLOWBEE.BAIXAR_DOCUMENTOS_SELECIONADOS](context, payload) {
        const url = `api/licitacoes/virtualizacao/multiplos-documentos/download`
        const {data} = await axios.post(url, payload, {
            responseType: 'blob'
        })

        downloadUtils.baixarBlob(data, 'documentos_selecionados', mimeTypes.zip.valor)
    },

    async [actionTypes.FLOWBEE.BAIXAR_ARQUIVO](context, paramObj) {
        try {
            const {data} = await axios.get(
                `api/v1/filemanager/download?` +
                ParamUtils.ObjectsToParams([paramObj]),
                {
                    responseType: 'arraybuffer'
                }
            )
            downloadUtils.baixarBlob(data, paramObj.nomeArquivo, mimeTypes.pdf.valor)
        } catch (error) {
            const msg = "Erro ao realizar o download do arquivo."
            console.error(msg, error);
            context.commit(mutationTypes.MOSTRAR_MENSAGEM_ERRO, msg);
        }
    },

    async [actionTypes.FLOWBEE.BAIXAR_ARQUIVO_USUARIO_LOGADO](context, paramObj) {
        const {data} = await axios.get(
            `api/licitacoes/filemanager/download?` +
            ParamUtils.ObjectsToParams([paramObj]),
            {
                responseType: 'arraybuffer'
            }
        )
        downloadUtils.baixarBlob(data, paramObj.nomeArquivo, mimeTypes.pdf.valor)
    },

    async [actionTypes.NOTIFICAR_DOCUMENTOS_EDITAL](context, licitacaoId) {
        const {data} = await axios.get(`api/licitacoes/notificarDocumentosEdital/${licitacaoId}`)
        return data
    },

    async [actionTypes.REENVIAR_DOCUMENTOS_COM_ERRO_PNCP](context, {licitacaoId, documentosIds}) {
        const {data} = await axios.post(`api/licitacoes/v2/${licitacaoId}/manutencao/anexos/publicar-pncp`, documentosIds)
        return data
    },

    async [actionTypes.BUSCAR_MODELOS_DESENTRANHAMENTO]() {
        const {data} = await axios.get(`api/v1/buscar-modelo-desentranhar`)
        return data
    },

    async [actionTypes.FLOWBEE.DESENTRANHAR_DOCUMENTO](context, payload) {
        const url = `api/licitacoes/${payload.licitacaoId}/documentos/${payload.documentoId}/desentranhar`
        const {data} = await axios.put(url, payload)
        return data
    },

    async [actionTypes.FLOWBEE.REORDENAR_DOCUMENTO](context, payload) {
        const url = `api/licitacoes/${payload.licitacaoId}/documentos/reordenar`
        const {data} = await axios.post(url, payload)
        return data
    },

    async [actionTypes.FLOWBEE.BUSCAR_TODOS_DOC_JUNTADO_PROCESSO](context, licitacaoId) {
        const url = `api/licitacoes/${licitacaoId}/documentos/juntados`
        const {data} = await axios.get(url)
        return data
    },

    async [actionTypes.BUSCAR_NUMERO_HASH]({state}, hash) {
        let {paginacao} = state.compararHash
        const urlBase = `api/licitacoes/compararHash/isProtocolo=${hash.isProtocolo}/numeroHash=${hash.numero}`
        const url = SearchUrlBuilder.build(urlBase, {}, paginacao)
        const {data} = await axios.get(url)
        return data
    },

    async [actionTypes.BUSCAR_PROTOCOLOS]({state}, tipo) {
        const {filtros, paginacao} = state.protocoloBusca
        const url = AzSearchUrlBuilder.build(`api/licitacoes/protocolos/tipo=${tipo}`, filtros, paginacao)
        const {data} = await axios.get(url)
        return data
    },

    async [actionTypes.BUSCAR_PROTOCOLO_DETALHE](context, {documentoId, tipo}) {
        const {data} = await axios.get(`api/licitacoes/buscarProtocoloDetalhe/${documentoId}/tipo=${tipo}`)
        return data
    },

    async [actionTypes.GERAR_RECIBO_DE_PROTOCOLO](context, {documentoId, tipo}) {
        axios({
            url: `api/licitacoes/gerarReciboDeProtocolo/${documentoId}/tipo=${tipo}`,
            method: 'GET',
            responseType: 'blob',
        }).then((response) => {
            var fileURL = window.URL.createObjectURL(new Blob([response.data]))
            var fileLink = document.createElement('a')

            fileLink.href = fileURL
            fileLink.setAttribute('download', 'ReciboDeProtocolo.pdf')
            document.body.appendChild(fileLink)

            fileLink.click()
        })
    },

    async [actionTypes.GERAR_TERMO_ACEITE](context, licitacaoId) {
        const {data} = await axios.get(`api/propostas/${licitacaoId}/documentos/termoaceite`)
        return data
    },

    async [actionTypes.EXISTE_PROPOSTA_ENVIADA](context, licitacaoId) {
        const {data} = await axios.get(`api/propostas/${licitacaoId}/enviada`)
        return data
    },

    async [actionTypes.CRIAR_TERMO_ACEITE](context, termo) {
        const {data} = await axios.post(`api/declaracao-termo`, termo)
        return data
    },

    async [actionTypes.ATUALIZAR_TERMO_ACEITE](context, payload) {
        const {data} = await axios.put(`api/declaracao-termo/${payload.termo.id}`, payload)
        return data
    },

    async [actionTypes.BUSCAR_TERMO_ACEITE]({state}, termoId) {
        const {data} = await axios.get(`api/declaracao-termos/${termoId}`)
        return data
    },

    async [actionTypes.BUSCAR_TERMOS_ACEITE]({state}) {
        const {filtros, paginacao} = state.termosBusca
        const url = AzSearchUrlBuilder.build('api/declaracao-termos/termos', filtros, paginacao)
        const {data} = await axios.get(url)
        return data
    },

    async [actionTypes.BUSCAR_TERMOS](context, licitacaoId) {
        const {data} = await axios.get(`api/licitacoes/${licitacaoId}/declaracoes`)
        return data
    },

    async [actionTypes.BUSCAR_SITUACAO_INTEGRACOES]({commit}) {
        commit(mutationTypes.LOKI.DISABLE_GLOBAL_LOADING)
        let source = axios.CancelToken.source()
        setTimeout(() => {
            source.cancel()
        }, 10000)

        const {data} = await axios.get('api/v1/informacoes-sistema/status',
            {cancelToken: source.token}
        )
        commit(mutationTypes.LOKI.ENABLE_GLOBAL_LOADING)
        return data
    },

    /**
     * TODO INICIO CREDENCIAMENTO >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>
     */

    async [actionTypes.CREDENCIAMENTO.BUSCAR_CREDENCIAMENTOS]({state}) {
        const {filtros, paginacao} = state.credenciamentoBusca
        const url = AzSearchUrlBuilder.build('api/credenciamentos/', filtros, paginacao)
        const {data} = await axios.get(url)
        return data
    },

    async [actionTypes.CREDENCIAMENTO.SOLICITACAO.INSERIR_DOCUMENTOS_SOLICITACAO_CREDENCIAMENTO](context, {
        licitacaoId,
        documentos
    }) {
        await axios.post(`api/credenciamento/${licitacaoId}/solicitacao/documentos`, documentos)
    },

    async [actionTypes.CREDENCIAMENTO.BUSCAR_DOCUMENTOS_CREDENCIAMENTO](context, {
        credenciamentoId,
        filtros,
        paginacao
    }) {
        const urlBase = `api/credenciamento/${credenciamentoId}/documentos`
        const url = SearchUrlParamBuilder.build(urlBase, filtros, paginacao)
        const {data} = await axios.get(url)
        return data
    },

    async [actionTypes.CREDENCIAMENTO.SOLICITACAO.INSERIR_NOVO_DOCUMENTO_SOLICITACAO_CREDENCIAMENTO](context, {
        credenciamentoId,
        documento
    }) {
        const response = await axios.post(`api/credenciamentos/${credenciamentoId}/solicitacao/novo-documento`, documento)
        return response
    },

    async [actionTypes.CREDENCIAMENTO.SOLICITACAO.REMOVER_DOCUMENTO_SOLICITACAO_CREDENCIAMENTO](context, {
        licitacaoId,
        documentoId
    }) {
        await axios.delete(`api/credenciamento/${licitacaoId}/solicitacao/documentos/${documentoId}`)
    },

    async [actionTypes.CREDENCIAMENTO.SOLICITACAO.BUSCAR_DOCUMENTOS_SOLICITACAO_CREDENCIAMENTO](context, licitacaoId) {
        const {data} = await axios.get(`api/credenciamento/${licitacaoId}/solicitacao/documentos`)
        return data
    },

    async [actionTypes.CREDENCIAMENTO.SOLICITACAO.PARTICIPAR_SOLICITACAO_CREDENCIAMENTO](context, licitacaoId) {
        const {data} = await axios.put(`api/credenciamento/${licitacaoId}/solicitacao/participar`)
        return data
    },

    async [actionTypes.CREDENCIAMENTO.SOLICITACAO.BUSCAR_SOLICITACAO_CREDENCIAMENTO]({state}, licitacaoId) {
        const paginacao = state.credenciamento.paginacao
        const url = SearchUrlBuilder.build(`api/credenciamento/${licitacaoId}/solicitacao`, {}, paginacao)
        const {data} = await axios.get(url)
        return data
    },

    async [actionTypes.CREDENCIAMENTO.SOLICITACAO.BUSCAR_RESULTADOS_SOLICITACOES_CREDENCIAMENTO]({state}, licitacaoId) {
        const paginacao = state.resultadoSolicitacaoCredenciamento.paginacao
        const url = SearchUrlBuilder.build(`api/credenciamento/${licitacaoId}/analiseSolicitacaoCredenciamento/solicitacao/buscarResultados`, {}, paginacao)
        const {data} = await axios.get(url)
        return data
    },

    async [actionTypes.CREDENCIAMENTO.ANALISE_SOLICITACAO_CREDENCIAMENTO.INSERIR_ANALISE_SOLICITACAO_CREDENCIAMENTO](context, licitacaoId) {
        const {data} = await axios.post(`api/credenciamento/${licitacaoId}/analiseSolicitacaoCredenciamento`)
        return data
    },

    async [actionTypes.CREDENCIAMENTO.ANALISE_SOLICITACAO_CREDENCIAMENTO.BUSCAR_ANALISE_SOLICITACAO_CREDENCIAMENTO_EM_ANALISE]({commit}, licitacaoId) {
        const {data} = await axios.get(`api/credenciamento/${licitacaoId}/analiseSolicitacaoCredenciamento/buscarAnaliseSolicitacaoCredenciamentoEmAnalise`)
        commit(mutationTypes.CREDENCIAMENTO.SET_ANALISE_SOLICITACAO_CREDENCIAMENTO_EM_ANALISE, data)
        return data
    },

    async [actionTypes.CREDENCIAMENTO.ANALISE_SOLICITACAO_CREDENCIAMENTO.FINALIZAR_ANALISE_SOLICITACAO_CREDENCIAMENTO](context, params) {
        const {data} = await axios.put(`api/credenciamento/${params.licitacaoId}/analiseSolicitacaoCredenciamento/${params.analiseSolicitacaoCredenciamentoId}/finalizar`, null, {ignorarRedirecionamento404: true})
        return data
    },

    async [actionTypes.CREDENCIAMENTO.ANALISE_SOLICITACAO_CREDENCIAMENTO.BUSCAR_RELATORIOS_ANALISES_SOLICITACOES_CREDENCIAMENTO]({commit}, licitacaoId) {
        const {data} = await axios.get(`api/credenciamento/${licitacaoId}/analiseSolicitacaoCredenciamento/buscarRelatoriosAnalisesSolicitacoesCredenciamentoFinalizadas`)
        commit(mutationTypes.CREDENCIAMENTO.ANALISE_SOLICITACAO_CREDENCIAMENTO.SET_RELATORIOS_ANALISES_SOLICITACOES_CREDENCIAMENTO, data)
        return data
    },

    async [actionTypes.CREDENCIAMENTO.ANALISE_SOLICITACAO_CREDENCIAMENTO.BUSCAR_DOCUMENTOS_ANALISE_SOLICITACAO_CREDENCIAMENTO](context, dados) {
        const {data} = await axios.get(`api/credenciamento/${dados.licitacaoId}/analiseSolicitacaoCredenciamento/solicitacao/${dados.solicitacaoId}/documentos`)
        return data
    },

    async [actionTypes.CREDENCIAMENTO.ANALISE_SOLICITACAO_CREDENCIAMENTO.ATUALIZAR_ANALISE_DE_DOCUMENTO_SELECIONADO](context, dados) {
        const {data} = await axios.put(`api/credenciamento/${dados.credenciamentoId}/analiseSolicitacaoCredenciamento/documentos`, dados)
        return data
    },

    async [actionTypes.CREDENCIAMENTO.SOLICITACAO.CREDENCIAR](context, {
        licitacaoId,
        analiseSolicitacaoCredenciamentoId,
        solicitacaoCredenciamentoId,
        dados
    }) {
        const {data} = await axios.post(`api/credenciamento/${licitacaoId}/analiseSolicitacaoCredenciamento/${analiseSolicitacaoCredenciamentoId}/solicitacaoCredenciamento/${solicitacaoCredenciamentoId}/credenciar`, dados) //NOSONAR
        return data
    },

    async [actionTypes.CREDENCIAMENTO.SOLICITACAO.NAO_CREDENCIAR](context, {
        licitacaoId,
        analiseSolicitacaoCredenciamentoId,
        solicitacaoCredenciamentoId,
        dados
    }) {
        const {data} = await axios.post(`api/credenciamento/${licitacaoId}/analiseSolicitacaoCredenciamento/${analiseSolicitacaoCredenciamentoId}/solicitacaoCredenciamento/${solicitacaoCredenciamentoId}/naoCredenciar`, dados) //NOSONAR
        return data
    },

    async [actionTypes.CREDENCIAMENTO.DOCUMENTO.ENVIAR_PNCP](context, {credenciamentoId, tipoDocumento, entidadeId}) {
        const {data} = await axios.post(`api/credenciamento/${credenciamentoId}/documentos/enviar-pncp`, {
            tipoDocumento,
            entidadeId
        })
        return data
    },

    async [actionTypes.CREDENCIAMENTO.DOCUMENTO.REMOVER_PNCP](context, {credenciamentoId, tipoDocumento, entidadeId}) {
        const url = `api/credenciamento/${credenciamentoId}/documentos/remover-pncp`
        // axios.delete supports a request body via the `data` option
        const {data} = await axios.delete(url, {data: {tipoDocumento, entidadeId}})
        return data
    },

    [actionTypes.CREDENCIAMENTO.BAIXAR_DOCUMENTO](context, documento) {
        const downloadLink = document.createElement('a')
        downloadLink.href = documento.url
        downloadLink.setAttribute('type', 'hidden')
        downloadLink.setAttribute('download', 'Arquivo.pdf')
        document.body.appendChild(downloadLink)
        downloadLink.click()
        document.body.removeChild(downloadLink)
    },

    [actionTypes.CREDENCIAMENTO.ANALISE_SOLICITACAO_CREDENCIAMENTO.BUSCAR_DADOS_CABECALHO_CREDENCIAMENTO](context, params) {
        return axios.get(`api/credenciamento/${params.licitacaoId}/analiseSolicitacaoCredenciamento/solicitacao/${params.idSolicitacao}/buscarCabecalhoAnaliseSolicitacaoCredenciamento`) //NOSONAR
    },

    [actionTypes.CREDENCIAMENTO.ALTERAR_SITUACAO_DOCUMENTO_CREDENCIAMENTO](context, params) {
        const {credenciamentoId, solicitacaoId, documentoId, ...body} = params
        return axios.put(`api/credenciamentos/${credenciamentoId}/solicitacoes/${solicitacaoId}/documentos/${documentoId}/alterarSituacao`, body) //NOSONAR
    },

    [actionTypes.CREDENCIAMENTO.SOLICITACAO.REENVIAR_DOCUMENTOS](context, {credenciamentoId, solicitacaoId}) {
        return axios.put(`api/credenciamentos/${credenciamentoId}/solicitacoes/${solicitacaoId}/documentos/reenviar`) //NOSONAR
    },

    async [actionTypes.CREDENCIAMENTO.DOCUMENTO.ASSINAR_ELETRONICAMENTE](context, {idVirtualizado, idLicitacao}) {
        const {data} = await axios.post('api/licitacoes/documentos/assinar-eletronicamente', {
            idDocumentoVirtualizado: idVirtualizado,
            licitacaoId: idLicitacao
        })
        return data
    },

    async [actionTypes.CREDENCIAMENTO.REMOVER_CREDENCIAMENTO](context, {credenciamentoId}) {
        await axios.delete(`api/credenciamentos/${credenciamentoId}/remover`)
    },

    async [actionTypes.CREDENCIAMENTO.SOLICITACAO.BUSCAR_CLASSIFICACOES_DISPONIVEIS](context, params) {
        return axios.get(`api/credenciamento/${params.pregaoId}/analiseSolicitacaoCredenciamento/classificacoesDisponiveis`, {
            params: {
                numeracao: params.numeracao,
                page: 1,
                size: 10
            }
        })
    },

    async [actionTypes.CREDENCIAMENTO.SOLICITACAO.ATRIBUIR_CLASSIFICACAO_AO_PARTICIPANTE](context, params) {
        const {data} = await axios.post(`api/credenciamento/${params.pregaoId}/analiseSolicitacaoCredenciamento/${params.analiseSolicitacaoCredenciamentoId}/solicitacaoCredenciamento/${params.solicitacaoCredenciamentoId}/classificar`, params)
        return data
    },

    async [actionTypes.CREDENCIAMENTO.DESPUBLICAR_CREDENCIAMENTO](context, params) {
        const {data} = await axios.post(`api/credenciamentos/${params.credenciamentoId}/despublicacao`, params)
        return data
    },

    async [actionTypes.CREDENCIAMENTO.ALTERAR_DATA_FIM_CREDENCIAMENTO](context, {credenciamentoId, dataFimCredenciamento}) {
        const {data} = await axios.put(`api/credenciamentos/${credenciamentoId}/data-fim`, {dataFimCredenciamento})
        return data
    },

    [actionTypes.CREDENCIAMENTO.SOLICITACAO.BAIXAR_TODOS_DOCUMENTOS](context, params) {
        return axios({
            url: `api/credenciamento/${params.licitacaoId}/analiseSolicitacaoCredenciamento/solicitacao/${params.solicitacaoId}/baixarTodosDocumentos`,
            method: 'GET',
            responseType: 'blob',
        }).then(response => {
            const url = window.URL.createObjectURL(new Blob([response.data]))
            const link = document.createElement('a')
            link.href = url
            link.setAttribute('download', downloadUtils.gerarNomeArquivoComData('DocumentosFornecedor'))
            document.body.appendChild(link)
            link.click()
            document.body.removeChild(link)
            window.URL.revokeObjectURL(url)
        }).catch(error => console.error(error))
    },

    async [actionTypes.CREDENCIAMENTO.SOLICITACAO.SALVAR_ITENS](context, {
        credenciamentoId,
        itens,
        itensInserir,
        itensRemover
    }) {
        const body = (itensInserir || itensRemover) ? {
            itensInserir: itensInserir || [],
            itensRemover: itensRemover || []
        } : {itens: itens}
        const {data} = await axios.post(`api/credenciamentos/${credenciamentoId}/solicitacoes/salvar-itens`, body)
        return data
    },

    async [actionTypes.CREDENCIAMENTO.BUSCAR_LOTES_CRDENCIAMENTO]({commit}, credenciamentoId) {
        const {data} = await axios.get(`api/credenciamentos/${credenciamentoId}/lotes-itens`)
        commit(mutationTypes.SET_LOTES_LICITACAO, data)
    },

    async [actionTypes.CREDENCIAMENTO.CANCELAR_PARTICIPACAO_LOTES_CRDENCIAMENTO](context, {
        credenciamentoId,
        licitacaoLoteItemId
    }) {
        await axios.delete(`api/credenciamentos/${credenciamentoId}/lotes-itens/${licitacaoLoteItemId}`)
    },

    async [actionTypes.CREDENCIAMENTO.ANALISE_SOLICITACAO_CREDENCIAMENTO.BUSCAR_DETALHE_ITENS_FORNECEDOR](context, {
        credenciamentoId,
        solicitacaoCredenciamentoId,
        fornecedorId
    }) {
        const {data} = await axios.get(`api/credenciamentos/${credenciamentoId}/solicitacoes/${solicitacaoCredenciamentoId}/fornecedores/${fornecedorId}`)
        return data
    },

    async [actionTypes.CREDENCIAMENTO.DEMANDA.BUSCAR_DEMANDAS_CREDENCIAMENTO](context, {
        credenciamentoId,
        fornecedorId,
        paginacao
    }) {
        const filtros = {}
        if (fornecedorId) {
            filtros.fornecedorId = fornecedorId
        }
        const urlBase = `api/credenciamentos/${credenciamentoId}/demandas`
        const url = SearchUrlParamBuilder.build(urlBase, filtros, paginacao)
        const {data} = await axios.get(url)
        return data
    },

    async [actionTypes.CREDENCIAMENTO.DEMANDA.BUSCAR_UNIDADES_ORGANIZACIONAIS](context, idOrgao) {
        const {data} = await axios.get(`api/orgaos/${idOrgao}/unidades-organizacionais`)
        return data
    },

    async [actionTypes.CREDENCIAMENTO.DEMANDA.BUSCAR_ORGAOS_USUARIO_POR_FUNCAO](context, funcao) {
        const {data} = await axios.get(`api/orgao?funcao=${encodeURIComponent(funcao)}`)
        return data
    },

    async [actionTypes.CREDENCIAMENTO.DEMANDA.BUSCAR_CREDENCIADOS](context, credenciamentoId) {
        const {data} = await axios.get(`api/credenciamentos/${credenciamentoId}/demandas/fornecedores-classificados`)
        return data
    },

    async [actionTypes.CREDENCIAMENTO.DEMANDA.BUSCAR_ITENS_CREDENCIAMENTO](context, {
        credenciamentoId,
        fornecedorId,
        paginacao
    }) {
        const urlBase = `api/credenciamentos/${credenciamentoId}/fornecedores/${fornecedorId}/itens`
        const url = SearchUrlParamBuilder.build(urlBase, {}, paginacao)
        const {data} = await axios.get(url)
        return data
    },

    async [actionTypes.CREDENCIAMENTO.DEMANDA.ADICIONAR_NOVA_DEMANDA](context, {credenciamentoId, dados}) {
        const {data} = await axios.post(`api/credenciamentos/${credenciamentoId}/demandas/inserir`, dados)
        return data
    },

    async [actionTypes.CREDENCIAMENTO.DEMANDA.BUSCAR_ITENS_POR_DEMANDA](context, {demandaId, paginacao}) {
        const urlBase = `api/credenciamentos/demandas/${demandaId}/itens`
        const url = SearchUrlParamBuilder.build(urlBase, {}, paginacao)
        const {data} = await axios.get(url)
        return data
    },

    async [actionTypes.CREDENCIAMENTO.DEMANDA.EDITAR_CANCELAR_DEMANDA](context, dados) {
        const {demandaId, dados: body} = dados
        const {data} = await axios.put(`api/credenciamentos/demandas/${demandaId}`, body)
        return data
    },
    async [actionTypes.CREDENCIAMENTO.DEMANDA.BUSCAR_DEMANDA_POR_ID](context, {demandaId}) {
        // eslint-disable-next-line
        console.log('demanda id actions: ', demandaId);
        const {data} = await axios.get(`api/credenciamentos/demandas/${demandaId}`)
        return data
    },

    async [actionTypes.CREDENCIAMENTO.DEMANDA.EXPORTAR_DEMANDA_PARA_CONTRATOS](context, {demandaId}) {
        await axios.post(`api/credenciamentos/demandas/${demandaId}/exportar-para-contratos`, {});
    },

    async [actionTypes.CREDENCIAMENTO.DEMANDA.BUSCAR_DOCUMENTOS_CONTRATACAO](context, { credenciamentoId, demandaId, filtros }) {
        const urlBase = `api/credenciamentos/${credenciamentoId}/demandas/${demandaId}/documentos`;
        const url = filtros ? SearchUrlParamBuilder.build(urlBase, filtros, null) : urlBase;
        const { data } = await axios.get(url);
        return data;
    },

    async [actionTypes.CREDENCIAMENTO.DEMANDA.SALVAR_DOC_DEMANDAS_CREDENCIAMENTO](context, {credenciamentoId, demandaId, documentos}) {
        const {data} = await axios.post(`api/credenciamentos/${credenciamentoId}/demandas/${demandaId}/documentos`, { documentos })
        return data
    },

    async [actionTypes.CREDENCIAMENTO.SOLICITACAO.SOLICITAR_ASSINATURA](context, {solicitacaoCredenciamentoId}) {
        await axios.put(`api/credenciamentos/solicitacao/${solicitacaoCredenciamentoId}/documentos/solicitar-assinatura`, {});
    },
    /**
     * TODO FIM CREDENCIAMENTO >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>
     */

    async [actionTypes.BUSCAR_LINHAS_FORNECIMENTO_EXTERNAS](context, conteudo) {
        const {data} = await axios.get(`api/v1/linha-fornecedores/externo?conteudo=${conteudo}`)
        return data
    },

    async [actionTypes.BUSCAR_LINHAS_FORNECIMENTO](context, licitacaoId) {
        const {data} = await axios.get(`api/v1/licitacoes/${licitacaoId}/linha-fornecedores`)
        return data
    },

    async [actionTypes.ADICIONAR_LINHA_FORNECIMENTO](context, {licitacaoId, objLinha}) {
        const {data} = await axios.post(`api/v1/licitacoes/${licitacaoId}/linha-fornecedores`, objLinha)
        return data
    },

    async [actionTypes.REMOVER_LINHA_FORNECIMENTO](context, {licitacaoId, linhaId}) {
        const {data} = await axios.delete(`api/v1/licitacoes/${licitacaoId}/linha-fornecedores/${linhaId}`, linhaId)
        return data
    },

    async [actionTypes.ATUALIZAR_DADOS_SGC](context, {licitacaoId}) {
        const {data} = await axios.put(`api/licitacoes/${licitacaoId}/lotes/atualizarDadosSGC`)
        return data
    },
    async [actionTypes.BUSCAR_MOEDAS_DISPONIVEIS_PREGAO_FORNECEDOR](context, licitacaoId) {
        const {data} = await axios.get(`api/licitacoes/${licitacaoId}/moedas-disponiveis`);
        return data;
    },
    async [actionTypes.BUSCAR_MOEDA_SELECIONADA_FORNECEDOR](context, {licitacaoId, fornecedorId}) {
        const {data} = await axios.get(`api/licitacoes/public/${licitacaoId}/moeda-selecionada/${fornecedorId}`);
        return data;
    },

    async [actionTypes.BAIXAR_RELATORIO_DOWNLOAD_EDITAL](context, payload) {
        try {
            const response = await axios.get(`api/anexodownload/relatorio?` +
                ParamUtils.ObjectsToParams([payload]),
                {
                    responseType: 'blob'
                }
            );

            const fileURL = window.URL.createObjectURL(new Blob([response.data], {type: 'application/pdf'}));
            const fileLink = document.createElement('a');

            fileLink.href = fileURL;
            fileLink.setAttribute('target', '_blank');
            document.body.appendChild(fileLink);

            fileLink.click();

            document.body.removeChild(fileLink);

        } catch (error) {
            console.error('Erro ao baixar o relatório', error);
        }
    },

    async [actionTypes.BUSCAR_RELATORIOS_READEQUACAO_PROPOSTA](context, licitacaoId) {
        const {data} = await axios.get(`api/propostas/${licitacaoId}/readequacao/relatorios`)
        return data
    },

    async [actionTypes.BUSCAR_PROPOSTAS_FORNECEDOR](context, licitacaoId) {
        const {data} = await axios.get(`api/propostas/${licitacaoId}/readequacao`)
        return data
    },

    [actionTypes.SALVAR_ITENS_READEQUADOS](context, itens) {
        return axios.post(`api/propostas/readequacao/inserir-valor-unitario`, itens)
            .then(response => {
                const status = response.status;
                const data = response.data;
                return {data, status};
            })
            .catch(error => {
                const status = error.response ? error.response.status : 500;
                const message = error.response ? error.response.data.message : 'Erro desconhecido';
                return {error: true, status, message};
            });
    },

    [actionTypes.ENVIAR_PROPOSTAS_READEQUADAS](context, propostas) {
        return axios.post(`api/propostas/readequacao/enviar`, propostas)
            .then(response => {
                const status = response.status;
                const data = response.data;
                return {data, status};
            })
            .catch(error => {
                const status = error.response ? error.response.status : 500;
                const message = error.response ? error.response.data.message : 'Erro desconhecido';
                return {error: true, status, message};
            });
    },

    async [actionTypes.DESINSCREVER_FORNECEDOR_EMAILS_LICITACAO](context, dados) {
        const {data} = await axios.post(`api/licitacoes/${dados.licitacaoId}/desinscrever-fornecedor`);
        return data;
    },

    async [actionTypes.BUSCAR_LICITACAO_RETORNAR](context, dados) {
        const {data} = await axios.get(`api/licitacoes/${dados.licitacaoId}`)
        return data;
    },

    async [actionTypes.BUSCAR_MODALIDADES]() {
        const {data} = await axios.get(`api/licitacoes/modalidades`)
        return data
    },

    async [actionTypes.BUSCAR_CATEGORIAS]() {
        const {data} = await axios.get(`api/licitacoes/categorias`)
        return data
    },

    async [actionTypes.BUSCAR_ESPECIFICACOES_RAMO](context, dados) {
        const {data} = await axios.get(`api/licitacoes/especificacoes/categoria/${dados.categoriaTipo}`)
        return data
    },

    [actionTypes.NOVA_PREPUBLICACAO](context, payload) {
        return axios.post(`api/licitacoes/prepublicacao`, payload)
            .then(response => {
                const status = response.status;
                const data = response.data;
                return {data, status};
            })
            .catch(error => {
                const status = error.response ? error.response.status : 500;
                const message = error.response ? error.response.data.message : 'Erro desconhecido';
                return {error: true, status, message};
            });
    },

    [actionTypes.EXCLUIR_PREPUBLICACAO](context, licitacaoId) {
        return axios.delete(`api/licitacoes/${licitacaoId}/prepublicacao`)
            .then(response => {
                const status = response.status;
                const data = response.data;
                return {data, status};
            })
            .catch(error => {
                const status = error.response ? error.response.status : 500;
                const message = error.response ? error.response.data.message : 'Erro desconhecido';
                return {error: true, status, message};
            });
    },

    async [actionTypes.BUSCAR_PROCOTOLO](context, payload) {
        const {data} = await axios.get(`api/licitacoes/${payload.licitacaoId}/esfinge/buscar-protocolo/${payload.operacao}`, payload)
        return data
    },

    [actionTypes.EXCLUIR_OCORRENCIA](context, {licitacaoId, historicoId}) {
        return axios.delete(`api/licitacoes/${licitacaoId}/ocorrencialicitacao/${historicoId}`)
            .then(response => {
                const status = response.status;
                const data = response.data;
                return {data, status};
            })
            .catch(error => {
                const status = error.response ? error.response.status : 500;
                const message = error.response ? error.response.data.message : 'Erro desconhecido';
                return {error: true, status, message};
            });
    },

    [actionTypes.INSERIR_OCORRENCIA](context, payload) {
        return axios.post(`api/licitacoes/ocorrencias`, payload)
            .then(response => {
                const status = response.status;
                const data = response.data;
                return {data, status};
            })
            .catch(error => {
                const status = error.response ? error.response.status : 500;
                const message = error.response ? error.response.data.message : 'Erro desconhecido';
                return {error: true, status, message};
            });
    },

    [actionTypes.ALTERAR_OCORRENCIA](context, payload) {
        return axios.put(`api/licitacoes/ocorrencias`, payload)
            .then(response => {
                const status = response.status;
                const data = response.data;
                return {data, status};
            })
            .catch(error => {
                const status = error.response ? error.response.status : 500;
                const message = error.response ? error.response.data.message : 'Erro desconhecido';
                return {error: true, status, message};
            });
    },

    async [actionTypes.BUSCAR_LOTES_DESERTO_FRACASSADO_OCORRENCIA](context, licitacaoId) {
        const {data} = await axios.get(`api/licitacoes/${licitacaoId}/ocorrencias/lotes-deserto-fracassado`)
        return data
    },

    async [actionTypes.BUSCAR_HISTORICOS_OCORRENCIA](context, licitacaoId) {
        const {data} = await axios.get(`api/licitacoes/${licitacaoId}/ocorrencias/historicos`)
        return data
    },

    async [actionTypes.GERAR_ATA_USIGA]({commit}, paramObj) {
        const formattedIdProcessoLicita = paramObj.idProcessoLicita.replace('/', '-')
        try {
            const response = await axios.get(
                `api/licitacoes/usiga/gerarAta?idProcessoLicita=${formattedIdProcessoLicita}&idLote=${paramObj.loteId}`,
                {responseType: 'arraybuffer'}
            )

            downloadUtils.baixarBlob(response.data, 'ATA.pdf', mimeTypes.pdf.valor)
        } catch (error) {
            commit(mutationTypes.MOSTRAR_MENSAGEM_ERRO, "Não foi encontrada ATA para a Licitação")
        }
    },

    async [actionTypes.BUSCAR_LOTES_PREGAO_USIGA](context, idProcessoLicita) {
        const formattedIdProcessoLicita = idProcessoLicita.replace('/', '-')
        const {data} = await axios.get(`api/legado/buscarLotes?idProcessoLicita=${formattedIdProcessoLicita}`)
        return data
    },

    async [actionTypes.DOWNLOAD_ANEXO_USIGA](context, paramObj) {

        const {data} = await axios.get(`api/legado/download/${paramObj.idAnexo}?tipo=${paramObj.tipo}`,
            {
                responseType: 'arraybuffer'
            }
        )

        downloadUtils.baixarBlob(data, paramObj.nomeAnexo, mimeTypes.pdf.valor)
    },

    async [actionTypes.BUSCAR_DOCUMENTOS_FORNECEDORES_USIGA](context, payload) {
        const formattedLicitacaoId = payload.idProcesso.replace('/', '-')
        const {data} = await axios.get("api/usiga/buscar-documentos-fornecedores", {
            params: {idProcesso: formattedLicitacaoId, idLote: payload.idLote, idFornecedor: payload.idFornecedor}
        });

        return data;
    },

    async [actionTypes.DOWNLOAD_ANEXO_DOC_FORNECEDOR](context, paramObj) {

        const {data} = await axios.get(`api/usiga/buscar-documentos-fornecedores/${paramObj.idAnexo}`,
            {
                responseType: 'arraybuffer'
            }
        )

        downloadUtils.baixarBlob(data, paramObj.nomeAnexo, mimeTypes.pdf.valor)
    },

    async [actionTypes.ATUALIZAR_PROPOSTA_PRAZO](context, {licitacaoId, fornecedorId, prazoValidade, prazoEntrega}) {
        const params = new URLSearchParams();
        params.append('fornecedorId', fornecedorId);
        if (prazoValidade) {
            params.append('prazoValidade', prazoValidade);
        }
        if (prazoEntrega) {
            params.append('prazoEntrega', prazoEntrega);
        }
        const {data} = await axios.post(`api/propostas/${licitacaoId}/prazos?${params.toString()}`);
        return data;
    },

    async [actionTypes.MANUTENCAO.ATUALIZAR_PERMISSOES_FORNECEDOR]() {
        const {data} = await axios.post('api/manutencao/corrigirPermissoesFornecedor')
        return data;
    },

    async [actionTypes.INSERIR_ESCLARECIMENTO_IMPUGNACAO_SERVIDOR](context, payload) {

        const formData = new FormData()
        formData.append('input', new Blob([JSON.stringify(payload)], {type: 'application/json'}))
        if (payload.anexoUpload) {
            formData.append('anexo', payload.anexoUpload)
        }
        await axios.post(`api/licitacoes/${payload.licitacaoId}/esclarecimentoImpugnacao/inserir-manual`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        })
    },

    async [actionTypes.VERIFICAR_PERMISSAO_ORGAO](context, payload) {
        const {data} = await axios.get(`api/licitacoes/perfilacesso/verificar?idOrgao=${payload.idOrgao}&perfilNome=${payload.perfilNome}`, payload)
        return data
    },

    async [actionTypes.BUSCAR_PROTOCOLOS_FORNECEDOR](context, licitacaoId) {
        const {data} = await axios.get(`api/licitacoes/buscar-protocolos-enviados/${licitacaoId}`)
        return data
    },
}
